// extracted by mini-css-extract-plugin
module.exports = {"Banner":"styles_Banner__zJyx4","tag":"styles_tag__16XaC","text":"styles_text__AU85p","bannerItem":"styles_bannerItem__Ym9vB"};